module.exports = new __parcel__URL__("clouds.0aa3f301.png").toString();